module.exports = __webpack_public_path__ + "static/media/chart2.4a6a85f4.jpg";